import {
    getBaccaratValue,
    getCardFaceValue,
    getColorValue,
    getDTFaceValue
} from '@/utils/card'
import { GameRoundState, RESULT } from '@/utils/constants'
import { Table } from 'vue'

export class GameResult {
    result!: number
    gameType: string
    state!: number
    isNewShoe!: boolean
    whoWin!: number
    bluePair = false
    redpair = false
    won = 0
    redTotal = 0
    blueTotal = 0
    redCard = new Array<string>()
    blueCard = new Array<string>()
    hasCardToDisplay = false
    isSuper6 = false
    mWin = -1

    constructor(table: Table) {
        this.whoWin = table.expand.whoWin
        this.mWin = table.expand.resultList[table.expand.resultList.length - 1]
        this.gameType = table.gameTypeNo

        // assign Cards
        if (table.expand.playerOne) this.blueCard.push(table.expand.playerOne)
        if (table.expand.playerTwo) this.blueCard.push(table.expand.playerTwo)
        if (table.expand.playerThree)
            this.blueCard.push(table.expand.playerThree)

        if (table.expand.bankerOne) this.redCard.push(table.expand.bankerOne)
        if (table.expand.bankerTwo) this.redCard.push(table.expand.bankerTwo)
        if (table.expand.bankerThree)
            this.redCard.push(table.expand.bankerThree)

        if (this.gameType === 'G002') {
            // read banker cards
            const bankerValue = new Array<number>()
            const bankerFaceValue = new Array<number>()
            let bankerTOtal = 0
            this.redCard.forEach(card => {
                const tempValue = getBaccaratValue(card)
                bankerValue.push(tempValue)
                bankerFaceValue.push(getCardFaceValue(card))
                bankerTOtal += tempValue
            })

            // read player cards
            const playerValue = new Array<number>()
            const playerFaceValue = new Array<number>()
            let playerTotal = 0
            this.blueCard.forEach(card => {
                const tempValue = getBaccaratValue(card)
                playerValue.push(tempValue)
                playerFaceValue.push(getCardFaceValue(card))
                playerTotal += tempValue
            })
            this.bluePair = playerFaceValue[0] === playerFaceValue[1]
            this.redpair = bankerFaceValue[0] === bankerFaceValue[1]
            bankerTOtal = bankerTOtal % 10
            playerTotal = playerTotal % 10

            this.redTotal = bankerTOtal
            this.blueTotal = playerTotal

            if (bankerTOtal === playerTotal) {
                this.whoWin = RESULT.GREEN
            } else if (bankerTOtal > playerTotal) {
                this.whoWin = RESULT.RED
            } else if (playerTotal > bankerTOtal) {
                this.whoWin = RESULT.BLUE
            }

            this.hasCardToDisplay =
                this.blueCard.length > 0 && this.redCard.length > 0
        } else if (this.gameType === 'G003') {
            const redTotal = getCardFaceValue(this.redCard[0])
            const blueTotal = getCardFaceValue(this.blueCard[0])

            this.redTotal = redTotal
            this.blueTotal = blueTotal

            if (redTotal === blueTotal) {
                // check dt face value
                const redFValue = getColorValue(this.redCard[0])
                const blueFValue = getColorValue(this.blueCard[0])
                if (redFValue === blueFValue) {
                    this.whoWin = RESULT.GREEN
                } else if (redFValue > blueFValue) {
                    this.whoWin = RESULT.TIGER
                } else if (blueFValue > redFValue) {
                    this.whoWin = RESULT.DRAGON
                }
            } else if (redTotal > blueTotal) {
                this.whoWin = RESULT.DRAGON
            } else if (blueTotal > redTotal) {
                this.whoWin = RESULT.TIGER
            }

            if (this.redCard[0] === '' || this.blueCard[0] === '') {
                this.hasCardToDisplay = false
            } else {
                this.hasCardToDisplay = true
            }
        }
    }
}
